<template>
  <v-snackbar
    v-model="snackbar"
    class="guidance-popup"
    :class="{ 'no-toolbar': !isAddOrEditPage }"
    content-class="guidance-content paragraph-xs py-2 px-3"
    timeout="-1"
    absolute
  >
    <span v-html="displayText || guidanceMessage"></span>
  </v-snackbar>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "GuidancePopup",

  props: {
    noAddEditPanel: {
      type: Boolean,
      default: false
    },
    displayText: {
      type: String,
      default: undefined
    }
  },
  data: () => ({
    snackbar: true
  }),
  computed: {
    ...mapState("MAP", ["guidanceMessage"]),
    isAddOrEditPage() {
      return this.$route.name.includes("Add") || this.$route.name.includes("Edit");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/variables.scss";

.guidance-popup {
  bottom: 140px;
  left: 0px;

  &.no-toolbar {
    bottom: 60px;
  }

  ::v-deep .bold {
    font-weight: 600;
  }
}

::v-deep .guidance-content {
  border-radius: var(--Layout-Spacing-100, 8px);
  background: var(--Colors-background-200, #2e3138);

  /* Card/Shadow Default */
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.08), 0px 10px 20px 0px rgba(0, 0, 0, 0.12);
  max-width: 256px;
  text-align: center;
}

::v-deep {
  .v-snack__wrapper {
    min-width: auto !important;
    min-height: 30px !important;
    height: fit-content !important;
  }

  .v-snack__action {
    margin: 0 !important;
  }
}
</style>
